interface AutoridadeSectionProps {
  onScrollTo: (id: string) => void;
}

const stats = [
  { icon: 'ri-trophy-fill', value: '38+', label: 'Anos de mercado' },
  { icon: 'ri-global-fill', value: '100+', label: 'Modelos no mercado internacional' },
  { icon: 'ri-star-fill', value: '1ª', label: 'Top model brasileira lançada' },
  { icon: 'ri-film-fill', value: 'TV & Moda', label: 'Atores e modelos nas maiores emissoras' },
];

const bullets = [
  { icon: 'ri-award-fill', text: 'Dirigida por Marla Drebes, referência nacional e internacional na descoberta de talentos.' },
  { icon: 'ri-book-fill', text: 'Marla Drebes está no RankBrasil em 2004, é a Primeira brasileira a descobrir e projetar uma top model made in Brasil: Shirley Mallmann foi lançada em janeiro de 1995.' },
  { icon: 'ri-user-star-fill', text: 'Responsável por lançar Shirley Mallmann — a primeira top model brasileira no cenário internacional.' },
  { icon: 'ri-flashlight-fill', text: 'Revelou talentos como Jeisa Chiminazzo e diversos nomes que atuam no Brasil e no exterior.' },
  { icon: 'ri-movie-2-fill', text: 'Trabalha também com atores, conectando talentos a testes nas maiores emissoras do país.' },
  { icon: 'ri-medal-fill', text: 'Histórico de grandes projetos e recordes nacionais no segmento da moda.' },
];

export default function AutoridadeSection({ onScrollTo }: AutoridadeSectionProps) {
  return (
    <section id="autoridade" className="py-16 sm:py-20 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-yellow-500/5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-14">
          <p className="text-xs sm:text-sm font-bold text-yellow-600 tracking-widest uppercase mb-3">
            Tradição &bull; Credibilidade &bull; Resultados
          </p>
          <h4 className="text-3xl sm:text-4xl md:text-5xl font-black text-black mb-3 px-4">
            <a href="#autoridade">
              Quem Está Por Trás da{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">Four Models?</span>
            </a>
          </h4>
          <p className="text-base sm:text-lg text-gray-500 max-w-2xl mx-auto">
            Mais de três décadas transformando vidas e lançando carreiras no mercado da moda e do entretenimento.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 mb-10 sm:mb-14">
          {stats.map((s) => (
            <div
              key={s.label}
              className="bg-black rounded-2xl p-5 sm:p-7 text-center border border-yellow-500/20 hover:border-yellow-500 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-11 h-11 sm:w-12 sm:h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-300">
                <i className={`${s.icon} text-lg sm:text-xl text-black`}></i>
              </div>
              <p className="text-2xl sm:text-3xl font-black text-yellow-500 mb-1">{s.value}</p>
              <p className="text-gray-400 text-xs sm:text-sm">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="bg-black rounded-2xl p-6 sm:p-8 md:p-10 border border-yellow-500/20 mb-8 sm:mb-10">
          <div className="space-y-4 sm:space-y-5">
            {bullets.map((b) => (
              <div key={b.icon} className="flex items-start gap-3 sm:gap-4">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${b.icon} text-base sm:text-lg text-black`}></i>
                </div>
                <p className="text-gray-300 text-sm sm:text-base leading-relaxed">{b.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <button
            type="button"
            onClick={() => onScrollTo('inscricao')}
            className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-8 sm:px-10 py-3.5 sm:py-4 rounded-full text-sm sm:text-base font-black hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-xl hover:shadow-yellow-500/30 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            GARANTIR MINHA VAGA
          </button>
        </div>
      </div>
    </section>
  );
}
